export default class StationAsset {
  constructor(obj) {
    this.id = obj.id
    this.heraldID = obj.heraldId
    this.name = obj.name
    this.safeName = obj.safeName
    this.streamUrl = obj.streamUrl
    this.logo = obj.logo
    this.squareLogo = obj.squareLogo
  }
}
